import HyperDX from '@hyperdx/browser';

declare global {
  interface Window {
    __HELP_CENTER_CONFIG__?: {
      PUBLIC_HYPERDX_API_KEY?: string;
    };
  }
}

export const onClientEntry = (): void => {
  const apiKey = window.__HELP_CENTER_CONFIG__?.PUBLIC_HYPERDX_API_KEY;

  if (!apiKey) {
    return;
  }

  HyperDX.init({
    apiKey,
    disableReplay: true,
    service: 'cc-help-center',
    url: 'https://clickstack-otel-browser.mgmt-core.connectedcare.io',
  });
};
